import TableResults from './TableResults';

export default TableResults;
